var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('navigation-desktop',{key:"nav-1"}):_c('navigation-mobile',{key:"nav-2"})}
var staticRenderFns = []

export { render, staticRenderFns }